var App = App || {};

App.Animations = (function ($) {

    'use strict';

    function ScrollAnimate() {
        $(".widget.widget-category").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".category-list-card", type: "animate__fadeInUp", stagger: 300 }
            ],
            overflow: false
        });

        $(".widget.widget-crosspromo").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-crosspromo-content > *", type: "animate__fadeIn", stagger: 200 }
            ],
            overflow: false
        });

        $(".widget.widget-homepage-banner").ZagScrollAnimate({
            offset: 100,
            targets: [
                { selector: ".homepage-banner-cards", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-information-band").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".helpful-tips", type: "animate__fadeInRight", stagger: 0 }
            ],
            overflow: true
        });

        $(".widget.widget-internal-masthead").ZagScrollAnimate({
            offset: 100,
            targets: [
                { selector: ".masthead-fadein", type: "animate__fadeIn", stagger: 300 }
            ],
            overflow: false
        });

        $(".widget.widget-rates-band").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".headline", type: "animate__fadeIn", stagger: 0 },
                { selector: ".rate-card-wrapper", type: "animate__fadeInUp", stagger: 300 }
            ],
            overflow: false
        });

        $(".widget.widget-resource-links").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".resource-links-title", type: "animate__fadeIn", stagger: 0 },
                { selector: ".resource-link", type: "animate__fadeInUp", stagger: 300 }
            ],
            overflow: false
        });

        $(".widget.widget-rich-text .rich-text-wrapper").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".rich-text", type: "animate__fadeIn", stagger: 300 }
            ],
            overflow: false
        });

        $(".widget.widget-solutions-finder").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".solutions", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });
    }

    return {
        ScrollAnimate: ScrollAnimate
    };

})(jQuery);

$(function () {
    App.Animations.ScrollAnimate();
});